export default
`  
  
    
   
    Hugo Music Player
    TTS designed for Chrome!
    File:
    alex_get_a_new_job.hugomusic
    [22 bytes]
    
   
   
    
   
`